import React, { useContext } from 'react';
import { CiImageOff } from 'react-icons/ci';
import { MdModeEditOutline, MdDelete } from 'react-icons/md';

import * as S from './styles';
import { RespTags, PriceTagProps } from 'types/PriceTagProps';
import PaginationComp from 'components/Pagination';
import { color } from 'styles/pallete';
import SwitchToggle from 'components/Buttons/SwitchToggleGeneral';
import { createTag } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { getTags } from 'pages/PriceTag/reqs';
import Load from 'components/Load';
import { editTag } from 'components/FormPriceTag/reqs';

interface ListPriceTagProps {
	isLoad: boolean;
	datalistTags: RespTags;
	setDataListTags: React.Dispatch<React.SetStateAction<RespTags>>;
	setTagToEdit: React.Dispatch<React.SetStateAction<PriceTagProps | null>>;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ListPriceTag({
	isLoad,
	datalistTags,
	setDataListTags,
	setTagToEdit,
	setIsOpenForm
}: ListPriceTagProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);

	function selectTagToEdit(tag: PriceTagProps) {
		setIsOpenForm(true);
		setTagToEdit(tag);
	}

	function returnPage() {
		if (datalistTags.page === 1) {
			return 1;
		}
		if (datalistTags.data.length === 1) {
			return datalistTags.page - 1;
		}

		return datalistTags.page;
	}

	async function deleteTag(tagToDelete: PriceTagProps) {
		setMessage('Deletando etiqueta');
		setIsOpenLoad(true);
		const isSuccess = await createTag(tagToDelete, handleNotify);

		if (isSuccess) {
			setMessage('Buscando lista atualizada');
			setIsOpenLoad(true);
			const { data, isSuccess } = await getTags(returnPage(), handleNotify);

			if (isSuccess && data) {
				setDataListTags(data);
			}
			setIsOpenLoad(false);
		}
		setIsOpenLoad(false);
	}

	async function editVisiableTag(tag: PriceTagProps) {
		setMessage('Mudando status da etiqueta');
		setIsOpenLoad(true);

		const tagCopy = structuredClone(tag);
		tagCopy.visible = !tagCopy.visible;

		const isSuccess = await editTag(tagCopy, handleNotify);

		if (isSuccess) {
			setMessage('Buscando lista atualizada');
			setIsOpenLoad(true);
			const { data, isSuccess } = await getTags(returnPage(), handleNotify);

			if (isSuccess && data) {
				setDataListTags(data);
			}
			setIsOpenLoad(false);
		}
		setIsOpenLoad(false);
	}

	return (
		<S.container>
			{isLoad ? (
				<S.centralizeLoad>
					<Load showText text="Carregando Tags" />
				</S.centralizeLoad>
			) : (
				<S.list>
					{datalistTags.data.length > 0 ? (
						datalistTags.data.map((tag) => (
							<S.itemTag key={tag.id}>
								<S.colorTag $color={tag.background_color} />
								<S.boxInfos>
									{tag.file !== null ? (
										<img src={tag.file.url} alt={tag.text} />
									) : (
										<CiImageOff />
									)}

									<S.infos>
										<p>
											<b>Priodade:</b> {tag.priority || 'Sem priodade'}
										</p>
										<p>
											<b>Conteúdo:</b> {tag.text || 'Etiqueta de imagem'}
										</p>
										<p>
											<b>Coleção:</b> {tag.vtex_cluster_name || 'Sem coleção'}
										</p>
									</S.infos>
								</S.boxInfos>

								<S.controls>
									<div title="Status da tag">
										<SwitchToggle
											isChecked={tag.visible}
											setIsChecked={() => {
												editVisiableTag(tag);
											}}
										/>
									</div>
									<MdModeEditOutline
										title="Editar"
										onClick={() => {
											selectTagToEdit(tag);
										}}
									/>
									<MdDelete
										title="Deletar"
										color={color.interface.red}
										onClick={() => {
											deleteTag(tag);
										}}
									/>
								</S.controls>
							</S.itemTag>
						))
					) : (
						<S.noTag>
							<p>Não há tags cadastrada</p>
						</S.noTag>
					)}
				</S.list>
			)}

			<PaginationComp
				actualPage={datalistTags?.page || 0}
				qtdPages={datalistTags?.totalPages || 0}
				getActualPage={(value) => {
					setDataListTags((obj) => ({ ...obj, page: Number(value) }));
				}}
			/>
		</S.container>
	);
}
